import { GET_PRODUCT_DISPUTE_REVIEWS } from "store/types";
import firebase from "../../config/firebase";
import { UPDATE_PRODUCT_DISPUTE_REVIEW } from "store/types";
import { createNullCache } from "@algolia/cache-common";
import algoliasearch from "algoliasearch";
const client = algoliasearch("AKYAZJGVV9", "f5306d66f87dbf20ad044268210656ed", {
  responsesCache: createNullCache(),
});
export const productIndex = client.initIndex("items");

export const getDiputeProductReviews =
  (item, search, batchSize = 2) =>
  async (dispatch, getState) => {
    await dispatch({ type: "LOADING", payload: true });
    try {
      if (search) {
        productIndex.search(search).then(async (response) => {
          dispatch({ type: "LOADING", payload: false });
          const objectIDs = response.hits.map((hit) => hit.objectID);
          console.log(objectIDs, "object");
          const matchingItems = [];

          for (const objectID of objectIDs) {
            const docRef = await firebase
              .firestore()
              .collection("productReviews")
              .where("productId", "==", objectID)
              .get();
            if (!docRef.empty) {
              docRef.forEach((doc) => {
                const data = doc.data();
                if (data.disputeStatus && data.disputeStatus === "disputed") {
                  matchingItems.push({ id: doc.id, ...data });
                }
              });
            }
          }

          console.log(matchingItems, "matching");

          dispatch({
            type: GET_PRODUCT_DISPUTE_REVIEWS,
            payload: matchingItems,
            productLastDocument: {},
            productActive: false,
          });
        });
      } else {
        const itemsRef = await firebase
          .firestore()
          .collection("productReviews")
          .where("disputeStatus", "==", "disputed");
        let query = itemsRef.orderBy("createdAt", "desc").limit(batchSize);
        if (item && item.productLastDocument) {
          query = query.startAfter(item.productLastDocument);
        }
        let isFirstFetch = item === null;
        const unsubscribe = query.onSnapshot(async (snapshot) => {
          const tempData = [];
          for (const doc of snapshot.docs) {
            const itemData = doc.data();
            tempData.push({
              ...itemData,
              id: doc.id,
            });
          }
          const productLastDocument =
            snapshot.docs.length > 0
              ? snapshot.docs[snapshot.docs.length - 1]
              : null;
          const newItem = { productLastDocument };
          const previousQuestions =
            getState().productDispute.disputeProductReviews;
          const newItems = tempData.filter((item) => {
            const exists = previousQuestions.some(
              (prevQuestion) => prevQuestion.id === item.id
            );
            return !exists;
          });
          let updatedItems = [];
          if (isFirstFetch) {
            isFirstFetch = false;
            dispatch({
              type: GET_PRODUCT_DISPUTE_REVIEWS,
              payload: tempData,
              productLastDocument: newItem,
              productActive: true,
            });
            dispatch({ type: "LOADING", payload: false });
          } else if (newItems.length > 0) {
            updatedItems = item
              ? [...previousQuestions, ...tempData]
              : tempData;
            dispatch({
              type: GET_PRODUCT_DISPUTE_REVIEWS,
              payload: updatedItems,
              productLastDocument: newItem,
              productActive: true,
            });
            dispatch({ type: "LOADING", payload: false });
          } else {
            updatedItems = item
              ? [...previousQuestions, ...tempData]
              : tempData;
            dispatch({
              type: GET_PRODUCT_DISPUTE_REVIEWS,
              payload: updatedItems,
              productLastDocument: newItem,
              productActive: false,
            });
            dispatch({ type: "LOADING", payload: false });
          }
        });
        return () => unsubscribe();
      }
    } catch (error) {
      console.log(error.message);
      dispatch({ type: "LOADING", payload: false });
    }
  };

//updateDisputeStatus

export const updateProductReviews = (reviewId, status) => async (dispatch) => {
  const productReviews = firebase.firestore().collection("productReviews");

  try {
    await productReviews.doc(reviewId).update({
      disputeStatus: status,
    });

    dispatch({ type: UPDATE_PRODUCT_DISPUTE_REVIEW, payload: reviewId });
  } catch (error) {
    console.error("Error publishing review:", error);
  }
};
